(function () {
  const AX = (window.RB.AnimKit = window.RB.AnimKit || {});
  const { EASE, Anim, play, later, setText, logFx } = AX;

  const MEDIA_RATE = [0.5, 4];

  const FADE_IN = 70;
  const FADE_OUT = 260;
  const SAFETY = 15000;
  const IMPACT_AT = 0.05;
  const SLAM = "cubic-bezier(.1,.86,.22,1)";
  const HANDOFF = 0.34;

  function el(cls, host) {
    const e = document.createElement("div");
    e.className = cls;
    if (host) host.appendChild(e);
    return e;
  }

  function splitName(name) {
    const i = String(name || "").indexOf(",");
    if (i < 0) return { head: String(name || ""), title: "" };
    return { head: name.slice(0, i).trim(), title: name.slice(i + 1).trim() };
  }

  function letters(host, text, dur, at) {
    const chars = String(text).split("");
    for (let i = 0; i < chars.length; i++) {
      const c = document.createElement("span");
      c.className = "fxcine-ch";
      c.textContent = chars[i] === " " ? " " : chars[i];
      host.appendChild(c);
      play(c, [
        { opacity: 0, transform: "translateY(-6px) scale(1.9)", filter: "blur(14px)" },
        { opacity: 1, transform: "translateY(0) scale(1)", filter: "blur(0)" },
      ], { duration: 190, delay: at + i * 13, easing: SLAM, fill: "both" });
    }
    play(host, [
      { letterSpacing: "40px" },
      { letterSpacing: "9px" },
    ], { duration: 320, delay: at, easing: SLAM, fill: "both" });
  }

  function nameGhost(plate, text, at) {
    const g = el("fxcine-ghost", plate);
    g.textContent = text;
    play(g, [
      { opacity: .85, transform: "scale(1)", filter: "blur(2px)" },
      { opacity: 0, transform: "scale(1.5)", filter: "blur(16px)" },
    ], { duration: 460, delay: at + 60, easing: "ease-out", fill: "both" });
  }

  function countUp(host, n, ms, at) {
    const gen = Anim._gen;
    const rate = Anim._rate;
    const t0 = Date.now() + at / rate;
    const tick = function () {
      if (Anim._gen !== gen || !host.parentNode) return;
      const k = Math.min(1, Math.max(0, (Date.now() - t0) * rate / ms));
      host.textContent = String(Math.round(n * (k * (2 - k))));
      if (k < 1) setTimeout(tick, 40);
    };
    host.textContent = "0";
    later(tick, at);
  }

  function mountPlate(host, s, cine, dur) {
    const card = s.card || {};
    const parts = splitName(cine.name || card.name);
    const plate = el("fxcine-plate", host);
    const rule = el("fxcine-rule", plate);
    const name = el("fxcine-name", plate);
    const sub = el("fxcine-sub", plate);
    const at = Math.round(dur * 0.26);

    const head = parts.head.toUpperCase();
    letters(name, head, dur, at);
    nameGhost(name, head, at);
    play(rule, [
      { opacity: 0, transform: "scaleX(0)" },
      { opacity: 1, transform: "scaleX(1.06)", offset: 0.42 },
      { opacity: .85, transform: "scaleX(1)" },
    ], { duration: 340, delay: at - 60, easing: SLAM, fill: "both" });

    if (parts.title) {
      const t = el("fxcine-title", sub);
      setText(t, parts.title);
    }
    if (typeof card.might === "number") {
      const m = el("fxcine-might", sub);
      const n = el("fxcine-mightn", m);
      const icon = el("fxcine-mighti", m);
      setText(icon, ":rb_might:");
      countUp(n, card.might, 380, at + 250);
      play(m, [
        { transform: "scale(1)" },
        { transform: "scale(1.22)", offset: 0.5 },
        { transform: "scale(1)" },
      ], { duration: 260, delay: at + 620, easing: EASE.settle, fill: "backwards" });
    }
    if (sub.children.length) {
      play(sub, [
        { opacity: 0, transform: "translateY(9px)", filter: "blur(6px)" },
        { opacity: 1, transform: "translateY(0)", filter: "blur(0)" },
      ], { duration: 260, delay: at + 190, easing: SLAM, fill: "both" });
    }
  }

  const GLYPHS = [
    "M0,-4 V4 M0,-4 L2.6,-1.6 M0,0 L2.6,2.4",
    "M-2.4,4 L0,-4 L2.4,4",
    "M-2.4,-4 L2.4,4 M2.4,-4 L-2.4,4",
    "M0,-4 V4 M-2.4,-1.8 H2.4",
    "M-2.4,-4 V4 M-2.4,-4 L2.4,0 L-2.4,4",
    "M-2.4,4 V-4 L2.4,-4 M-2.4,0 H1.6",
    "M0,-4 L2.4,0 L0,4 L-2.4,0 Z",
    "M-2.4,-4 V4 M2.4,-4 V4 M-2.4,-4 L2.4,4",
  ];

  function svg(tag, cls, host) {
    const e = document.createElementNS("http://www.w3.org/2000/svg", tag);
    if (cls) e.setAttribute("class", cls);
    if (host) host.appendChild(e);
    return e;
  }

  function ring(host, cls, r, n, scale, ticks) {
    const g = svg("g", "fxcine-ring " + cls, host);
    const c1 = svg("circle", "fxcine-ringline", g);
    c1.setAttribute("r", r);
    const c2 = svg("circle", "fxcine-ringline thin", g);
    c2.setAttribute("r", r - 6);
    for (let i = 0; i < n; i++) {
      const a = (360 / n) * i;
      const slot = svg("g", "", g);
      slot.setAttribute("transform", "rotate(" + a + ") translate(0," + -(r - 3) + ") scale(" + scale + ")");
      const p = svg("path", "fxcine-rune", slot);
      p.setAttribute("d", GLYPHS[(i * 3) % GLYPHS.length]);
      if (!ticks) continue;
      const tick = svg("path", "fxcine-tick", g);
      const b = a + 180 / n;
      tick.setAttribute("transform", "rotate(" + b + ")");
      tick.setAttribute("d", "M0," + -(r - 6) + " V" + -(r - 2.5));
    }
    return g;
  }

  function mountAura(stage, s, dur) {
    const aura = el("fxcine-aura", stage);
    el("fxcine-bloom", aura);
    const box = svg("svg", "fxcine-rings", aura);
    box.setAttribute("viewBox", "-100 -100 200 200");
    box.setAttribute("aria-hidden", "true");
    const outer = ring(box, "outer", 94, 28, 0.85, true);
    const inner = ring(box, "inner", 63, 16, 0.72, false);
    play(outer, [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
      { duration: 21000, iterations: Infinity, easing: "linear" });
    play(inner, [{ transform: "rotate(360deg)" }, { transform: "rotate(0deg)" }],
      { duration: 13000, iterations: Infinity, easing: "linear" });
    play(aura, [
      { opacity: 0, transform: "scale(1.5)" },
      { opacity: 1, transform: "scale(.97)", offset: 0.055 },
      { opacity: 1, transform: "scale(1)", offset: 0.1 },
      { opacity: .95, transform: "scale(1.04)" },
    ], { duration: dur, easing: SLAM, fill: "both" });
  }

  function impact(wrap, dur, at) {
    const flash = el("fxcine-flash", wrap);
    play(flash, [
      { opacity: 0 },
      { opacity: .92, offset: 0.06 },
      { opacity: .34, offset: 0.3 },
      { opacity: 0 },
    ], { duration: 320, delay: at, easing: "ease-out", fill: "both" });

    for (let i = 0; i < 2; i++) {
      const ring = el("fxcine-shock" + (i ? " thin" : ""), wrap);
      play(ring, [
        { opacity: 0, transform: "translate(-50%,-50%) scale(.12)" },
        { opacity: .95, transform: "translate(-50%,-50%) scale(.5)", offset: 0.16 },
        { opacity: 0, transform: "translate(-50%,-50%) scale(2.6)" },
      ], { duration: 620 + i * 160, delay: at + i * 90, easing: "cubic-bezier(.16,.84,.3,1)", fill: "both" });
    }

    const app = document.getElementById("app");
    if (app) {
      play(app, [
        { transform: "translate(0,0)" },
        { transform: "translate(7px,-5px)", offset: 0.14 },
        { transform: "translate(-6px,4px)", offset: 0.3 },
        { transform: "translate(4px,3px)", offset: 0.48 },
        { transform: "translate(-2px,-2px)", offset: 0.7 },
        { transform: "translate(0,0)" },
      ], { duration: 300, delay: at, easing: "ease-out" });
    }
  }

  function motes(wrap, dur) {
    const n = 26;
    for (let i = 0; i < n; i++) {
      const front = i % 3 !== 0;
      const m = el("fxcine-mote" + (front ? " front" : ""), wrap);
      const size = front ? 3 + Math.random() * 6 : 2 + Math.random() * 3;
      const life = 900 + Math.random() * 1500;
      m.style.width = size + "px";
      m.style.height = (size * (front ? 5 : 3)) + "px";
      m.style.left = (8 + Math.random() * 84) + "%";
      play(m, [
        { opacity: 0, transform: "translate3d(0, 30vh, 0) scale(.5)" },
        { opacity: front ? .9 : .55, offset: 0.18 },
        { opacity: 0, transform: "translate3d(" + (Math.random() * 60 - 30) + "px, -85vh, 0) scale(1.35)" },
      ], {
        duration: life, delay: Math.round(Math.random() * dur * 0.8),
        iterations: Math.ceil(dur / life) + 1, easing: "cubic-bezier(.3,.5,.4,1)", fill: "both",
      });
    }
  }

  function mountPlaceholder(stage, s, cine, dur) {
    const art = el("fxcine-art", stage);
    if (RB.hasArt(s.card)) {
      art.style.backgroundImage = RB.artCssAt(s.card, 520, true);
    }
    const glare = el("fxcine-glare", art);
    play(art, [
      { opacity: 0, transform: "scale(.78) translateY(30px)", filter: "brightness(2.4) blur(12px)" },
      { opacity: 1, transform: "scale(1) translateY(0)", filter: "brightness(1.05) blur(0)", offset: 0.3 },
      { opacity: 1, transform: "scale(1.05) translateY(0)", filter: "brightness(1) blur(0)", offset: 0.86 },
      { opacity: 0, transform: "scale(1.09) translateY(-6px)", filter: "brightness(1.6) blur(6px)" },
    ], { duration: dur, easing: EASE.arc, fill: "both" });
    play(glare, [
      { opacity: 0, transform: "translateX(-120%) skewX(-12deg)" },
      { opacity: .9, transform: "translateX(0%) skewX(-12deg)", offset: 0.5 },
      { opacity: 0, transform: "translateX(120%) skewX(-12deg)" },
    ], { duration: Math.round(dur * 0.55), delay: Math.round(dur * 0.22), easing: EASE.arc, fill: "both" });
    return dur;
  }

  function mountVideo(stage, cine, onReady, onFail) {
    const v = document.createElement("video");
    v.className = "fxcine-media";
    v.muted = !cine.audio;
    v.autoplay = true;
    v.preload = "auto";
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.setAttribute("disablepictureinpicture", "");
    v.style.objectFit = cine.fit;
    if (cine.poster) v.poster = cine.poster;
    for (const src of cine.sources) {
      const s = document.createElement("source");
      s.src = src;
      s.type = /\.mp4$/i.test(src) ? "video/mp4" : /\.mov$/i.test(src) ? "video/quicktime" : "video/webm";
      v.appendChild(s);
    }
    v.addEventListener("playing", onReady, { once: true });
    v.addEventListener("error", onFail);
    stage.appendChild(v);
    const started = v.play();
    if (started && typeof started.catch === "function") {
      started.catch(function () {
        if (v.muted) return;
        v.muted = true;
        const retry = v.play();
        if (retry && typeof retry.catch === "function") retry.catch(onFail);
      });
    }
    return v;
  }

  function runCine(s, dur) {
    const cine = s.cine;
    if (!cine) return null;
    const layer = Anim.layer();
    const wrap = el("fxcine", layer);
    el("fxcine-bg", wrap);
    const stage = el("fxcine-stage", wrap);
    const gen = Anim._gen;
    mountAura(stage, s, dur);
    motes(wrap, dur);
    if (cine.plate !== false) mountPlate(wrap, s, cine, dur);
    impact(wrap, dur, Math.round(dur * IMPACT_AT));

    let resolve = null;
    const finished = new Promise(function (r) { resolve = r; });
    let media = null;
    let closing = false;
    let waitTimer = null;
    let safety = null;

    const detach = function () {
      if (waitTimer) { clearTimeout(waitTimer); waitTimer = null; }
      if (safety) { clearTimeout(safety); safety = null; }
      document.removeEventListener("keydown", skip, true);
      wrap.removeEventListener("pointerdown", skip);
      if (media) { try { media.pause(); } catch (e) { } media.removeAttribute("src"); media = null; }
      const i = Anim._cleanup.indexOf(abort);
      if (i >= 0) Anim._cleanup.splice(i, 1);
    };

    function abort() {
      if (closing) return;
      closing = true;
      detach();
      try { wrap.remove(); } catch (e) { }
      resolve();
    }

    function close() {
      if (closing) return;
      closing = true;
      detach();
      wrap.style.pointerEvents = "none";
      wrap.style.zIndex = "88";
      play(wrap, [
        { opacity: 1, transform: "scale(1)" },
        { opacity: 0, transform: "scale(1.06)" },
      ], { duration: FADE_OUT, easing: "ease-in", fill: "forwards" });
      later(function () { try { wrap.remove(); } catch (e) { } }, FADE_OUT);
      later(resolve, Math.round(FADE_OUT * HANDOFF));
    }

    function skip(e) {
      if (e && e.type === "keydown" && e.key === "Tab") return;
      close();
    }

    function fallback() {
      if (closing) return;
      if (media) { try { media.remove(); } catch (e) { } media = null; }
      if (waitTimer) { clearTimeout(waitTimer); waitTimer = null; }
      const hold = mountPlaceholder(stage, s, cine, dur);
      later(function () { if (Anim._gen === gen) close(); }, hold);
    }

    Anim._cleanup.push(abort);
    document.addEventListener("keydown", skip, true);
    wrap.addEventListener("pointerdown", skip);
    play(wrap, [{ opacity: 0 }, { opacity: 1 }], { duration: FADE_IN, easing: "ease-out", fill: "backwards" });
    play(stage, [
      { transform: "scale(1.34)", filter: "blur(10px)" },
      { transform: "scale(1)", filter: "blur(0)", offset: 0.1 },
      { transform: "scale(1.06)", filter: "blur(0)" },
    ], { duration: dur, easing: SLAM, fill: "both" });

    if (!cine.sources.length) {
      fallback();
    } else {
      try {
        media = mountVideo(stage, cine, function () {
          if (waitTimer) { clearTimeout(waitTimer); waitTimer = null; }
          if (media) media.playbackRate = Math.max(MEDIA_RATE[0], Math.min(MEDIA_RATE[1], Anim._rate));
        }, fallback);
        media.addEventListener("ended", function () { if (Anim._gen === gen) close(); }, { once: true });
        waitTimer = setTimeout(fallback, cine.wait);
      } catch (e) {
        logFx(e);
        fallback();
      }
    }
    safety = setTimeout(function () { if (Anim._gen === gen) close(); }, SAFETY);
    return finished;
  }

  Object.assign(AX, { runCine: runCine });
})();
